var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings-helper-components-1-main-page"},[_c('SettingsHelperComponents2Header'),_c('SettingsHelperComponents3ResourceList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }